import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'

import {
  type StrategyMemo,
  useInvalidateArchivedStrategyMemosInfiniteQuery,
} from '../hooks/useArchivedStrategyMemosInfiniteQuery'
import { useUpdateStrategyMemoStatusMutation } from '../hooks/useUpdateStrategyMemoStatusMutation'

export type UnarchiveButtonProps = {
  strategyMemo: StrategyMemo
}

export const UnarchiveButton = ({ strategyMemo }: UnarchiveButtonProps) => {
  const { t } = useTranslation()
  const invalidateArchivedStrategyMemosInfiniteQuery =
    useInvalidateArchivedStrategyMemosInfiniteQuery()
  const updateStrategyMemoStatusMutation = useUpdateStrategyMemoStatusMutation({
    onSuccess: () => {
      invalidateArchivedStrategyMemosInfiniteQuery()
    },
  })

  const handleClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    updateStrategyMemoStatusMutation.mutate({
      strategyMemoId: strategyMemo.id,
      newStatus: 'active',
    })
  }, [strategyMemo.id, updateStrategyMemoStatusMutation])

  return (
    <StyledButton
      disabled={updateStrategyMemoStatusMutation.isPending}
      fillMode="outline"
      icon="undo"
      onClick={handleClick}
    >
      {t('restore')}
    </StyledButton>
  )
}
